export enum UserStatus {
  IS_LOGGED_IN = 'IS_LOGGED_IN',
  VALIDATING_LOGIN = 'VALIDATING_LOGIN',
  IS_NOT_LOGGED = 'IS_NOT_LOGGED',
  LOADING = 'LOADING',
  ERROR = 'ERROR',
}
